export const COLORS = [
  '#655728',
  '#2E7D32',
  '#1976D2',
  '#7B1FA2',
  '#C62828',
  '#F57C00',
  '#00695C',
  '#5D4037',
  '#455A64',
  '#6A1B9A',
  '#D32F2F',
  '#388E3C',
  '#1565C0',
  '#8E24AA',
  '#F44336',
  '#FF9800',
];
